// @flow

export const MAX_PRELOAD_HIT_THUMBNAIL = 3;

export const hitThumbnailBackgroundImageClass = (index: number) =>
    index < MAX_PRELOAD_HIT_THUMBNAIL ? `Hit__unveil--img${index}` : '';
